import * as React from 'react';
import * as styles from './Label.css';

export interface ILabelProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> {
  labelText: string;
}

export const Label = React.forwardRef(function Label(props: ILabelProps, ref: React.Ref<HTMLSpanElement>) {
  const { labelText, ...spanProps } = props;

  return (
    <span {...spanProps} className={styles['label']} ref={ref}>
      {labelText}
    </span>
  );
});
